import { gql } from "@apollo/client";

export const groupLabels = gql`
  query labels($filter: LabelFilterInput, $scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      labels(filter: $filter) {
        items {
          id
          code
          name
          category {
            id
            code
            name
            labelSource {
              id
              code
              name
            }
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

export const labelsByGroupId = gql`
  query labelsByGroupId(
    $scenarioId: ID!
    $originId: ID!
    $filter: GroupsManagerSearchFilterInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      groupsManagerSearch(filter: $filter) {
        items {
          id
          code
          name
          labels {
            id
            code
            name
            category {
              id
              code
              name
              labelSource {
                id
                code
                name
              }
            }
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
        __typename
      }
      __typename
    }
  }
`;
